import React from "react";
import { Link } from "react-router-dom";
import menu from "../assets/images/dinner-and-show-menu.jpg";

export default function DinnerAndShowPromoCard() {
  return (
    <div className="flex flex-col items-center gap-2 text-center md:flex-row md:items-center md:gap-3 md:text-left">
      <Link to="/dinner-and-show" className="shrink-0">
        <img
          src={menu}
          alt="Dinner and a Show menu"
          className="h-[140px] w-auto object-cover md:h-[160px]"
        />
      </Link>
      <div className="flex min-w-0 flex-col items-center md:items-start">
        <p className="m-0 text-base font-semibold leading-tight text-white md:text-lg">
          Dinner & A Show
        </p>
        <p className="mt-1.5 mb-0 text-xs leading-snug text-white/70 md:text-sm">
          Dining + a show at The Orleans
        </p>
        <Link
          to="/dinner-and-show"
          className="mt-2.5 inline-flex items-center justify-center rounded px-3.5 py-1.5 text-xs font-semibold leading-none text-white no-underline bg-[#0d5fb8] transition hover:bg-[#0b4f98] md:text-sm"
        >
          Build Your Night
        </Link>
      </div>
    </div>
  );
}
